import Vue from 'vue'
import _ from 'lodash'
import gravatar from 'gravatar'

Vue.filter('gravatar', function (value) {
  return (_.isString(value) && value) ? gravatar.url(value) : ''
})



// WEBPACK FOOTER //
// ./src/filters/index.js